import React from 'react';
import '../Styles/WhatWeDo.css';

const WhatWeDo = () => {
  return (
    <section className="what-we-do-section">
      <div className="what-we-do-container">
        {/* How It Works */}
        <div className="how-it-works-section" id="how-it-works">
          <h2>How It Works</h2>
          <div className="steps-container-horizontal">
            <div className="step-horizontal">
              <div className="step-icon">1</div>
              <h3>Source and activate qualified providers</h3>
              <p className="step-detail">Provider onboarding based on clinic criteria</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step-horizontal">
              <div className="step-icon">2</div>
              <h3>Providers set availability</h3>
              <p className="step-detail">Availability managed directly by providers</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step-horizontal">
              <div className="step-icon">3</div>
              <h3>Offer in-home care to new and existing patients</h3>
              <p className="step-detail">GetQuickCare creates personalised offers for new and existing patients, helping clinics convert</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step-horizontal">
              <div className="step-icon">4</div>
              <h3>Patients request in-home care</h3>
              <p className="step-detail">Availability is confirmed and payment is collected</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step-horizontal">
              <div className="step-icon">5</div>
              <h3>Providers deliver care & get paid</h3>
              <p className="step-detail">Automated confirmations, payouts, and follow-up reminders</p>
            </div>
          </div>
        </div>

        {/* Expansion Model Section */}
        <div className="revenue-section">
          <h2>Example: Med Spa Expansion</h2>
          <div className="revenue-calculation">
            <div className="revenue-amount">~$28,000 Additional Monthly Revenue</div>
            <div className="revenue-formula">5 Providers × 2 Visits/Week × 4 Weeks × $700 Avg Cost</div>
            <p className="revenue-subtext">Conservative utilization. Paid-per-visit structure.</p>
          </div>
        </div>

        {/* What GetQuickCare Really Is */}
        <div className="what-really-section">
          <h2>A New Revenue Stream Through In-Home Services</h2>
          <p className="what-really-intro">
            GetQuickCare helps clinics launch and operate in-home services using flexible, paid-per-visit providers.
          </p>
          <div className="what-really-content">
            <h3>Clinics use GetQuickCare to:</h3>
            <ul className="features-list">
              <li>Set clinic-specific activation criteria</li>
              <li>Operate on a paid-per-visit model</li>
              <li>Run clinic-branded patient acquisition funnels</li>
              <li>Automate confirmations and payout coordination</li>
            </ul>
            <div className="control-statements">
              <p>You control pricing.</p>
              <p>You control ads.</p>
              <p>You control provider standards.</p>
            </div>
            <div className="not-statements">
              <p><strong>This is not a staffing agency.</strong></p>
              <p><strong>We do not place full-time employees.</strong></p>
            </div>
          </div>
        </div>

        {/* Who This Is For */}
        <div className="who-section">
          <h2>Who This Is For</h2>
          <ul className="who-list">
            <li>Owner-led clinics</li>
            <li>Med spas and aesthetic clinics</li>
          </ul>
        </div>

        {/* Pricing Section */}
        <div className="pricing-section">
          <h2>Now Accepting Clinics Nationwide</h2>
          <div className="pricing-card">
            <div className="price"></div>
            <ul className="pricing-features">
              <li>Fully self-serve</li>
              <li>No long-term contracts</li>
              <li>Clinics control ad spend</li>
              <li>Includes provider activation</li>
              <li>Custom pricing based on clinic needs</li>
            </ul>
            <a
              href="https://shopify.getquickcare.com/products/founder-sprint-limited"
              className="pricing-cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Start Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
